import React, { useState, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Tab } from "@headlessui/react";
import { VendorTabs } from "./VendorTab";
import { useRecoilState, useRecoilValue } from "recoil";
import { permissionsSelector } from "../Login/selectors/permissionSelector";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router";
import { mainSelectedTab } from "./../CarrierAgreementMgmt/atoms";

const VendorTab = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const userPermissions = useRecoilValue(permissionsSelector);
  const [selectedIndex, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const [hover, setHover] = useState();
  const [distributedTabs, setDistributedTabs] = useState([]);
  const currentTabs = VendorTabs.filter((tabs) =>
    userPermissions.includes(tabs.permission)
  );
  const defaultTab = currentTabs.findIndex((c) => pathname.includes(c.to));
  useEffect(() => {
    if (distributedTabs.length === 0) {
      let array = [];
      const numOfArray = 2; // number of group tabs
      for (var i = 0; i < currentTabs?.length; i++) {
        array[i % numOfArray]
          ? array[i % numOfArray].push(i)
          : (array[i % numOfArray] = [i]);
      }

      setDistributedTabs(array);
    }
  }, []);

  useEffect(() => {
    if (defaultTab < 0) {
      history.push(currentTabs[0]?.to);
      setSelectedIndex(0);
    } else {
      if (selectedIndex > 0) {
        setSelectedIndex(defaultTab);
      } else {
        setSelectedIndex(defaultTab);
      }
    }
  }, [defaultTab]);

  return (
    <Router>
      <Tab.Group
        defaultIndex={defaultTab}
        selectedIndex={selectedIndex}
        onChange={setSelectedIndex}
      >
        <Tab.List
          className={`bg-tabColor sm:px-2 md:px-4 lg:px-8 pt-1 max-w-full text-white`}
          style={{
            gridTemplateColumns: `repeat(${currentTabs?.length}, minmax(0, 1fr)`,
          }}
        >
          {currentTabs?.map((item, index) => {
            const urlPath = {
              pathname: item.to,
            };
            return (
              <Tab
                key={index}
                onClick={() => {
                  setSelectedIndex(index);
                  history.push(urlPath);
                }}
                className=""
              >
                {({ selected }) => (
                  <div className="w-full">
                    <div
                      style={{
                        zIndex: selected
                          ? currentTabs?.length + 1
                          : hover === index
                          ? currentTabs?.length + 2
                          : currentTabs?.length - index,
                      }}
                      onMouseEnter={() => setHover(index)}
                      onMouseLeave={() => setHover(undefined)}
                      className={`inline-block whitespace-nowrap py-3 font-medium 
                        text-xs cursor-pointer tracking wide relative rounded-t-2xl
                        w-full 
                    
                        ${
                          index !== 0 //default tab color
                            ? index === currentTabs?.length - 1
                              ? "tab-leftLight tab-rightLight" //last tab
                              : "tab-leftLight tab-rightLight" //[0] first color of tab
                            : "tab-leftLight tab-rightLight" //first tab
                        } 
                          ${
                            selected &&
                            "min-w-max bg-white text-secondary font-bold" //for selected tab
                          }
                          ${
                            //curve for selected tab
                            selected && index === 0
                              ? "text-secondary tab-rightSelected tab-leftSelected" //if first tab is selected
                              : selected && index === currentTabs?.length - 1
                              ? "text-secondary tab-rightSelected tab-leftSelected" //if last tab is selected
                              : selected &&
                                index !== 0 &&
                                index !== currentTabs?.length - 1
                              ? "text-secondary tab-rightSelected tab-leftSelected" //default tabs
                              : "hover:min-w-max hover:bg-secondary hover:text-white"
                          }
                         `}
                    >
                      <div
                        className={
                          index === selectedIndex ||
                          index === selectedIndex - 1 ||
                          index === hover ||
                          (hover && index === hover - 1)
                            ? "flex items-center sm:px-2 md:px-4 lg:px-6"
                            : "border-r sm:px-2 md:px-4 lg:px-6 flex items-center"
                        }
                      >
                        <p>{item.icon}</p>
                        <p>{item.label}</p>
                      </div>
                    </div>
                  </div>
                )}
              </Tab>
            );
          })}
        </Tab.List>
        <Tab.Panels className="">
          {currentTabs?.map((child) => (
            <Tab.Panel key={child.to}>
              {React.createElement(child.component)}
            </Tab.Panel>
          ))}
        </Tab.Panels>
      </Tab.Group>
    </Router>
  );
};

export default VendorTab;
